import { render, staticRenderFns } from "./CourseQuestions.vue?vue&type=template&id=70c698f2&"
import script from "./CourseQuestions.vue?vue&type=script&lang=js&"
export * from "./CourseQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports